import React, { Component } from 'react';
import { Card, Form, Button, Row, Col, Container } from "react-bootstrap";
import axios from "axios";
import CommonLoader from '../loaderComponent/CommonLoader';
import { validateAddPermissionCodeForm, validateAddRoleForm } from '../../utils/validation';
import CommonToast from '../Toaster/CommonToast';

export default class AddPermissionCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
      name: "",
      hasError: false,
      errMsg: "",
      completed: false,
      loading: true,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      permissionData: this.props.location.state?.data
    };
  }

  componentDidMount() {
    const { permissionData } = this.state || {};
    console.log("permissionData", permissionData);
    if (permissionData) {
      this.setState({
        code: permissionData.code,
        name: permissionData.name,
        // ...other fields,
        permissionData,  // Also store the entire permissionData so you know you're in edit mode
      });
    }
    setTimeout(() => {
      this.setState({ loading: false })
    }, 900)
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
  };
  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ hasError: false, errMsg: "", completed: false, loading: true });
    const { code, name, permissionData } = this.state;
    const token = localStorage.getItem("token");
    const errors = validateAddPermissionCodeForm(code, name);
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    const permissionCodeData = { code, name };
    try {
      let userResponse;
      if (permissionData && permissionData.id) {
        userResponse = await axios.put(`/permission/${permissionData.id}`, permissionCodeData, { headers });
      } else {
        userResponse = await axios.post('/permission', permissionCodeData, { headers });
      }
      this.setState({
        completed: true,
        toastMessage: userResponse?.data?.message,
        toastVariant: 'success',
        color: 'green',
        showToast: true,
        code: "",
        name: "",
        errors: {}
      });

      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/permission-code-list");
      }, 900);
    } catch (error) {
      console.error("Error adding permission code:", error);
      let errorMessage = "Failed to add permission code.";

      if (error.response) {
        if (error.response.status === 400) {
          errorMessage = error.response.data.message;
        } else if (error.response.status === 403) {
          errorMessage = "Access Denied! Admin privileges required.";
        }
      }
      this.setState({
        hasError: true,
        errMsg: errorMessage,
        toastMessage: errorMessage,
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);
      window.scrollTo(0, 0);
    }
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/permission-code-list");
      this.setState({ loading: false });
    }, 500);
  }
  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>
          <Container className="pt-4">
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>  {this.state.permissionData?.id ? "Update Permission Code" : "Add Permission Code"}
                </strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  <Row className="mb-3">
                    <Col xs={12} md={6} lg={6}>
                      <Form.Group>
                        <Form.Label className="text-muted required"> Code</Form.Label>
                        <Form.Control
                          type="text"
                          name="code"
                          placeholder='Enter code name'
                          value={this.state.code}
                          onChange={this.handleChange}
                          disabled={!!this.state.permissionData?.id}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.code && <small className="text-danger">{this.state.errors.code}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                      <Form.Group>
                        <Form.Label className="text-muted required"> Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={1}
                          name="name"
                          placeholder='Enter description'
                          value={this.state.name}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.name && <small className="text-danger">{this.state.errors.name}</small>}
                      </span>
                    </Col>
                  </Row>
                  <div className='add-cancel-btn '>
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary"
                      type="submit" >
                      {this.state.permissionData?.id ? "Update" : "Add"}
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel"
                      onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Container>
        </CommonLoader>
      </>
    );
  }
}
